class MemberpressForm {
  constructor() {
    //=======================
    //JOIN US PAGE
    //Memberpress signin
    //=======================
    if (document.querySelector(".page-id-103927") && document.querySelector(".logged-in") && !document.querySelector(".admin-bar")) {
      document.querySelector(".join-us-offer").style.display = 'none'
    }
    if (document.getElementById("user_first_name1")) {
      document.getElementById("user_first_name1").placeholder = "First Name"
    }
    if (document.getElementById("user_last_name1")) {
      document.getElementById("user_last_name1").placeholder = "Last Name"
    }
    if (document.getElementById("user_email1")) {
      document.getElementById("user_email1").placeholder = "Email"
    }
    if (document.getElementById("mepr_user_password1")) {
      document.getElementById("mepr_user_password1").placeholder = "Password"
      this.passwordInput = document.getElementById("mepr_user_password1")
    }
    if (document.getElementById("mepr_user_password_confirm1")) {
      document.getElementById("mepr_user_password_confirm1").placeholder = "Password Confirmation"
    }
    if (document.querySelector(".stripe-card-name")) {
      document.querySelector(".stripe-card-name").placeholder = "Name on the card"
    }
    if (document.querySelector('.mepr-payment-methods-wrapper') && document.querySelector('.mepr-signup-form')) {
      let newNode = document.createElement("div")
      newNode.classList.add('password-requirement')
      newNode.innerHTML = `
      <h5>Password requirements:</h5>
        <div class="password-dynamic-list">
        <p>
          <i class="fa fa-check chara" aria-hidden="true"></i> 8 characters<br/>
          <i class="fa fa-check upper" aria-hidden="true"></i> Uppercase(s)
        </p>
        <p>
          <i class="fa fa-check num" aria-hidden="true"></i> Number(s)<br/>
          <i class="fa fa-check symb" aria-hidden="true"></i> Symbol(s)
        </p>
        </div>
      `

      // Obtient une référence au nœud parent
      let parentDiv = document.querySelector('.mepr-payment-methods-wrapper').parentNode

      // Commence le cas de test [ 1 ] : Existing childElement (tout fonctionne correctement)
      let sp2 = document.querySelector('.mepr-payment-methods-wrapper')
      parentDiv.insertBefore(newNode, sp2)
      // Fin du cas de test [ 1 ]
    }
    if (document.querySelector('.mepr-signup-form')) {
      document.querySelector('.mepr-submit').style.pointerEvents = 'none'
    }
    //=======================

    //=======================
    //LOGIN PAGE
    //Memberpress login
    if (document.querySelector('.page-id-103992')) {
      if (document.querySelector('.mepr_username')) {
        const el = document.querySelector('.mepr_username')
        const elLabel = el.getElementsByTagName("label")
        elLabel[0].innerHTML = ''
      }
      document.getElementById("user_login").placeholder = "Email"

      if (document.querySelector('.mepr_password')) {
        const el = document.querySelector('.mepr_password')
        const elLabel = el.getElementsByTagName("label")
        elLabel[0].innerHTML = ''
      }
      document.getElementById("user_pass").placeholder = "Password"
    }
    //=======================

    //=======================
    //ACCOUNT PAGE
    if (document.querySelector('.mepr-account-rebill')) {
      document.querySelector('.mepr-account-rebill').style.display = 'none'
    }
    //=======================
    this.events()
  }

  events() {
    if (this.passwordInput) {
      this.passwordInput.addEventListener("keyup", () => this.passwordRequirements())
    }
  }

  passwordRequirements() {
    let passwordRequirementGood = 0
    if (this.passwordInput.value.length > 7) {
      document.querySelector('.chara').style.color = 'black'
      passwordRequirementGood += 1
    } else {
      document.querySelector('.chara').style.color = 'silver'
      passwordRequirementGood -= 1
    }
    if (/[0-9]/.test(this.passwordInput.value)) {
      document.querySelector('.num').style.color = 'black'
      passwordRequirementGood += 1
    } else {
      document.querySelector('.num').style.color = 'silver'
      passwordRequirementGood -= 1
    }
    if (/[A-Z]/.test(this.passwordInput.value)) {
      document.querySelector('.upper').style.color = 'black'
      passwordRequirementGood += 1
    } else {
      document.querySelector('.upper').style.color = 'silver'
      passwordRequirementGood -= 1
    }
    if (/[-+_!@#$%^&*., ?]/.test(this.passwordInput.value)) {
      document.querySelector('.symb').style.color = 'black'
      passwordRequirementGood += 1
    } else {
      document.querySelector('.symb').style.color = 'silver'
      passwordRequirementGood -= 1
    }
    if (passwordRequirementGood == 4) {
      document.querySelector('.mepr-submit').style.pointerEvents = 'auto'
    }
  }


}

export default MemberpressForm